(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-captacion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('connectif-email-banner')) {
    class ConnectifEmailBanner extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.form = this.querySelector('.connectif-email-banner__form');
        this.emailInput = this.querySelector('input[name="email"]');
        this.honeypot = this.querySelector('input[name="company"]');
        this.button = this.querySelector('.connectif-email-banner__button');
        this.buttonLabel = this.button?.querySelector('span');
        this.status = this.querySelector('.connectif-email-banner__status');

        if (!this.form || !this.emailInput || !this.button || !this.status) return;

        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      async getConnectif() {
        for (let attempt = 0; attempt < 50; attempt += 1) {
          if (window.connectif?.managed?.sendEvents) return window.connectif;
          await new Promise((resolve) => window.setTimeout(resolve, 100));
        }

        throw new Error('Connectif unavailable');
      }

      setStatus(message, state) {
        this.status.textContent = message;
        this.status.dataset.state = state;
        this.status.hidden = false;
      }

      setLoading(isLoading) {
        this.button.disabled = isLoading;
        this.button.setAttribute('aria-busy', String(isLoading));

        if (!this.buttonLabel) return;

        this.buttonLabel.textContent = isLoading
          ? this.button.dataset.loadingLabel
          : this.button.dataset.defaultLabel;
      }

      async handleSubmit(event) {
        event.preventDefault();

        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return;
        }

        if (this.honeypot?.value) {
          this.form.reset();
          return;
        }

        const integrationMode = this.dataset.integrationMode?.trim() || 'connectif_js';
        const eventAlias = this.dataset.eventAlias?.trim();
        const proxyUrl = this.dataset.proxyUrl?.trim();
        const emailField = this.dataset.emailField?.trim() || 'email';
        const email = this.emailInput.value.trim();

        if (integrationMode === 'connectif_js' && !eventAlias) {
          this.setStatus(this.status.dataset.configError, 'error');
          return;
        }

        if (integrationMode === 'webhook_proxy' && !proxyUrl) {
          this.setStatus(this.status.dataset.configError, 'error');
          return;
        }

        this.setLoading(true);
        this.status.hidden = true;

        try {
          const payload = {};
          payload[emailField] = email;

          if (integrationMode === 'webhook_proxy') {
            const response = await fetch(proxyUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ email })
            });

            if (!response.ok) throw new Error('Proxy request failed');
          } else {
            const connectif = await this.getConnectif();

            await Promise.resolve(
              connectif.managed.sendEvents([
                {
                  type: 'custom',
                  eventAlias,
                  payload
                }
              ])
            );
          }

          this.form.reset();
          this.setStatus(this.status.dataset.success, 'success');
        } catch (error) {
          this.setStatus(this.status.dataset.error, 'error');
        } finally {
          this.setLoading(false);
        }
      }
    }

    customElements.define('connectif-email-banner', ConnectifEmailBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surprises-calendario-adviento"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('advent-splash')) {
    customElements.define('advent-splash', class AdventSplash extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-advent-splash-open]');
        this.dialog = this.querySelector('[data-advent-splash-dialog]');
        this.closeButton = this.querySelector('[data-advent-splash-close]');
        this.productImages = Array.from(this.querySelectorAll('[data-advent-product-image]'));

        if (!this.openButton || !this.dialog) return;

        this.openButton.addEventListener('click', () => this.openDialog());
        this.closeButton?.addEventListener('click', () => this.closeDialog());

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeDialog();
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeDialog();
        });
      }

      loadProductImages() {
        this.productImages.forEach((image) => {
          if (image.src) return;

          if (image.dataset.srcset) {
            image.srcset = image.dataset.srcset;
          }

          if (image.dataset.src) {
            image.src = image.dataset.src;
          }
        });
      }

      openDialog() {
        this.dialog.removeAttribute('data-closing');
        if (!this.dialog.open) this.dialog.showModal();
        window.requestAnimationFrame(() => this.loadProductImages());
      }

      closeDialog() {
        if (!this.dialog.open) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.dialog.close();
          return;
        }

        this.dialog.setAttribute('data-closing', '');
        window.setTimeout(() => {
          this.dialog.close();
          this.dialog.removeAttribute('data-closing');
        }, 240);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
